import React, { Fragment, useEffect, useRef, useState } from "react";
import { Alert, Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { useNavigate, useLocation } from 'react-router-dom';
import AuthService, { saveToken } from "Api/Auth";
import { Form, Formik } from 'formik';
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { setUserProfilePicture, setAdminId } from "reducers/UserProfile";
import { setUserRole } from 'reducers/UserPermission';
import { getCurrentRole } from "Components/Router/Permission";
import { toast } from "react-toastify";
import TwoFAModal from "Components/Modal/TwoFAModal";
import AdminService from "Api/Admin";
import Loader from 'react-loaders';
import Bugsnag from "@bugsnag/js";
import ClooserLogo from "../../../src/assets/utils/images/logo_Clooser_blue_orange.png";

import "../../../src/assets/pages/_loginBoxed.scss";
import { useThemeSettings } from "Api/Admin/Theme";

const baseUrl = process.env.REACT_APP_BASE_URL;
const validationSchema = Yup.object().shape({
    verification_code: Yup.string().required('Voer qrcode in'),
});
export const hasThirtyDaysPassed = (expiredDate) => {
    const expired = new Date(expiredDate);
    const now = new Date();

    return now.getTime() > expired.getTime();
}

// Layout
const SignupSchema = Yup.object().shape({
    username: Yup.string()
        .required('Gebruikersnaam is verplicht')
        .min(3, "Gebruikersnaam moet minimaal 3 tekens bevatten")
        .max(50, 'Gebruikersnaam mag maximaal 50 tekens bevatten'),
    password: Yup.string()
        .required('Wachtwoord is verplicht')
        .min(8, "Wachtwoord moet minimaal 8 tekens bevatten")
        .max(50, 'Het wachtwoord mag maximaal 50 tekens bevatten'),
});

const getCookie = (cookieName) => {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
        const [name, value] = cookie.split("=");
        if (name === cookieName) {
            return value;
        }
    }
    return null;
};

const LoginBoxed = () => {

    const [showOTPModal, setShowOTPModal] = useState(false);
    const [isUseDetailSet, setISUserDetailsSet] = useState(false);
    const [data, setData] = useState('')
    const [loading, setLoading] = useState(true);
    const [otp, setOtp] = useState('');
    const [userResponse, setUserResponse] = useState({});
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [showQRModal, setShowQRModal] = useState(false);
    const [qrCodeSVG, setQrCodeSVG] = useState('');
    const [recoveryCode, setRecoveryCode] = useState(null);
    const [verifyType, setVerifyType] = useState(null);
    const [ButtonDisabled, setButtonDisabled] = useState(false);
    const [verifyEnable, setVerifyEnable] = useState(null);
    const [qrError, setQrError] = useState('');
    const [error, setError] = useState(false);
    const [emailSent, setEmailSent] = useState(false);
    const [timer, setTimer] = useState(300);
    // new: password visibility toggle for the redesigned field
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const hasRedirectedRef = useRef(false);
    const logoRef = useRef(null);
    let navigate = useNavigate();


    useEffect(() => {
        if (AuthService.checkUserLoggedIn()) {
            const rolesString = localStorage.getItem('USER_ROLES');
            const roles = rolesString && rolesString !== 'undefined' ? JSON.parse(rolesString) : [];

            const isAdmin = roles.includes("administrator");
            const is2FAVerified = localStorage.getItem("2fa_verified") === "true";
            const isImpersonating = localStorage.getItem("IS_IMPERSONATE") === "1";
            if (isAdmin && !is2FAVerified && isImpersonating) {
                setLoading(false);
                navigate("/login");
                return;
            }
            if (roles.length === 0) {
                setLoading(false);
                navigate("/login");
            } else {
                navigate(getCurrentRole(roles).route);
            }
        }
        else {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (!showOTPModal) return;


        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            window.history.pushState(null, "", window.location.href);

        };
        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [showOTPModal]);

    useEffect(() => {
        const savedEndTime = localStorage.getItem("otpTimerEnd");
        const mailSent = localStorage.getItem("otpMailSent");

        if (!savedEndTime || mailSent !== "true") return;

        const remaining = Math.floor((savedEndTime - Date.now()) / 1000);

        if (remaining > 0) {
            setEmailSent(true);
            setTimer(remaining);
        } else {
            localStorage.removeItem("otpTimerEnd");
            localStorage.removeItem("otpMailSent");
            setEmailSent(false);
        }
    }, []);

    useEffect(() => {
        let interval;

        if (emailSent && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [emailSent, timer]);

    const handleForgotPassword = (e) => {
        e.preventDefault();
        navigate('/forgot-password');
    };
    const formatTime = (seconds) => {
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s < 10 ? "0" : ""}${s}`;
    };


    const handleSubmit = async (data) => {
        setIsButtonDisabled(true);
        try {
            const rememberToken = getCookie("rememberToken");

            const result = await AuthService.login(
                data.username,
                data.password,
                rememberToken || undefined
            ).catch((e) => {
                setIsButtonDisabled(false);
            });

            if (result && result.status === 200 && result.data) {
                localStorage.removeItem("otpTimerEnd");
                setError("");

                let response = result.data;

                if (response.error) {
                    setError(response.error);
                    setIsButtonDisabled(false);
                    return;
                }
                setData(response);
                saveToken(response);

                !response.roles.includes("administrator") &&
                    AuthService.makeAuth(response);

                if (
                    response.enabled === 0 &&
                    response.roles.includes("administrator") &&
                    response.bTwoFaMandatoryForAdministrators == true
                ) {
                    const roles = AuthService.applySessionRoles(response);
                    dispatch(setUserRole(roles));
                    setShowQRModal(true);
                    generateQR(response.user.iAdminId);
                    return;
                } else {
                    setShowQRModal(false);
                }

                // Show app notification, but continue login flow
                if (response.appLastThreeMLogin == false) {
                    toast.success(
                        "Klaar om slimmer te werken? Gebruik de Clooser app en ervaar het verschil. Beschikbaar via Google play store en Apple App store",
                        {
                            autoClose: 20000,
                            closeButton: true,
                        }
                    );
                }

                // Continue normal login flow
                if (
                    response.roles.length === 0 ||
                    response.roles[0] === ""
                ) {
                    setError(
                        "U heeft niet de juiste rol om in te loggen op dit systeem"
                    );
                    setIsButtonDisabled(false);
                } else {
                    const isUserRemembered =
                        response.vRememberToken != null &&
                        response.vRememberToken === rememberToken;

                    if (
                        response.enabled &&
                        !isUserRemembered &&
                        response.bTwoFaMandatoryForAdministrators == true
                    ) {
                        setUserResponse(response);
                        setShowOTPModal(true);
                    } else {
                        if (
                            response.vRememberToken != null &&
                            response.vRememberToken !== rememberToken
                        ) {
                            setFrontendCookie(
                                "rememberToken",
                                response.vRememberToken
                            );
                        }

                        setUserDetails(response);
                    }
                }
            } else {
                setError(result.data.error);
                setIsButtonDisabled(false);
            }
        } catch (error) {
            let response = error?.response?.data;

            if (
                response?.error !== undefined &&
                response?.error !== ""
            ) {
                setError(response?.error);
                setIsButtonDisabled(false);
            }
        }
    };


    function setUserDetails(response) {
        if (hasRedirectedRef.current) return;
        hasRedirectedRef.current = true;
        AuthService.makeAuth(response);
        const roles = AuthService.applySessionRoles(response);
        dispatch(setUserRole(roles));
        dispatch(setUserProfilePicture(response.user.profileImage));
        dispatch(setAdminId(response.user.iAdminId));
        const redirectRaw = localStorage.getItem("redirectAfterLogin");
        if (redirectRaw) {
            let web = null;
            let mobile = null;

            try {
                const parsed = JSON.parse(redirectRaw);
                web = parsed.web;
                mobile = parsed.mobile;
            } catch (e) {
                web = redirectRaw;
            }

            localStorage.removeItem("redirectAfterLogin");

            const targetRoute = web || mobile;


            navigate(targetRoute, {
                replace: true,
            });

            return;
        } else {
            navigate(getCurrentRole(roles).route);
        }

    }

    const handleOTPSubmit = async (values) => {
        setError("")
        const verificationType =
            verifyEnable
                ? verifyEnable === "email"
                    ? "email"
                    : "auth"
                : (data?.enabled === 1 && data?.twoFactors === "email"
                    ? "email"
                    : "auth");
        const payload = {
            code: otp,
            remember: values.rememberOTP ? 1 : 0,
            verification_type: verificationType,

        };

        const url = `${baseUrl}/api/2fa`;

        try {
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userResponse.token.access_token}`,
                },
                method: 'POST',
                body: JSON.stringify(payload),
            });

            const responseData = await response.json();

            Bugsnag.notify("Testing Bugsnag");

            if (!responseData) {
                toast.error("Fout bij invoeren van de OTP. Serverfout!");
                return;
            }

            if (responseData?.status) {
                localStorage.setItem("2fa_verified", "true");
                localStorage.removeItem("otpTimerEnd");
                localStorage.removeItem("otpEmailSent", 'false');
                if (values.rememberOTP) {
                    setFrontendCookie("rememberToken", responseData.rememberToken);
                }

                setShowOTPModal(false);
                setOtp('');
                setUserDetails(userResponse);
                setISUserDetailsSet(prev => !prev);

            } else {
                setError('onjuiste code')
                localStorage.removeItem("user");
                localStorage.removeItem("2fa_verified");
                setOtp('');
            }
        } catch (error) {
            console.error('Fout tijdens OTP-inzending:', error);

        }

    };
    // Function to set cooki
    const setFrontendCookie = (cookieName, cookieValue) => {
        let expires = new Date();
        expires.setFullYear(expires.getFullYear() + 100);
        document.cookie = `${cookieName}=${cookieValue}; expires=${expires.toUTCString()}; path=/; secure; samesite=strict`;
    };
    const generateQR = (iAdminId) => {
        setQrCodeSVG('');
        setQrError('');
        AdminService.getQR(iAdminId)
            .then((response) => {
                if (response?.data?.status) {
                    setQrCodeSVG(response?.data.qr);
                    setQrError('');
                } else {
                    setQrCodeSVG('');
                    setQrError("QR-generatie mislukt. Probeer het opnieuw!");
                }
            })
            .catch((error) => {
                console.error(error);
                setQrCodeSVG('');
                setQrError('Er is iets misgegaan. Probeer het alstublieft opnieuw.');
            });
    }

    const enableTwoFactorAuthentication = (values, setFieldError) => {
        setButtonDisabled(true);
        const verificationType = data?.enabled === 1 && data?.twoFactors === "email"
            ? "auth"
            : "mail";
        const payload = { verification_code: values.verification_code, iEnable: 1, verification_type: verificationType };

        AdminService.postQRCode(payload)
            .then((response) => {
                if (response?.data?.status) {
                    const codes = response?.data?.recoveryCodes;
                    if (response.data.verification_way === 'auth') {
                        setVerifyType('auth');
                        setVerifyEnable('auth')
                        setShowOTPModal(true)
                        return;
                    }
                    if (!codes || codes.length === 0) {
                        setShowQRModal(false);
                        navigate('/beheerder')
                    } else {
                        setRecoveryCode(codes);
                    }
                    setQrCodeSVG('');
                } else {
                    setFieldError("verification_code", "onjuiste code");
                }
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setButtonDisabled(false);
            })
    }

    const handleLink = (setFieldValue) => {
        AdminService.handleEmailLink().then((res) => {
            if (res.data.status) {
                const endTime = Date.now() + 300 * 1000;

                localStorage.setItem("otpTimerEnd", endTime);
                localStorage.setItem("otpMailSent", "true");

                setEmailSent(true);
                setTimer(300);
            }
        })
            .catch((error) => {
                console.error(error)
            })
    }

    const toggleModal = () => {
        setVerifyEnable(null);
        setShowQRModal(!setShowQRModal);
        setQrError('');
        setRecoveryCode(null);
        navigate('/beheerder')
    }


    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <Fragment>
            <div className="forgot-password-page">
             
                <div className="backdrop" aria-hidden="true">
                    <div className="circle circle-blue"></div>
                    <div className="circle circle-orange"></div>
                    <div className="circle circle-outline"></div>
                </div>

                <header className="page-header">
                    <a className="quiet-link back-link" href="https://clooser.nl/">
                        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 5-7 7 7 7M5 12h14" /></svg>
                        Naar clooser.nl
                    </a>
                    <nav className="header-actions" aria-label="Ondersteuning">
                        <a className="help-link status-link" href="https://www.clooserstatus.nl/" target="_blank" rel="noopener noreferrer">
                            Systeemstatus
                            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M7 7h10v10" /></svg>
                        </a>
                        <a className="help-link" href="https://www.clooser.nl/vervangers/contact/" target="_blank" rel="noopener noreferrer">
                            <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 0 1 5 .5c0 2-2.5 2-2.5 4M12 17h.01" /></svg>
                            Hulp nodig?
                        </a>
                    </nav>
                </header>

                <main className="login-form-page">
                    <div className="login-wrap">
                        <a className="brand" href="https://clooser.nl/" aria-label="Clooser.nl, naar de website">
                            <img
                                ref={logoRef}
                                src={ClooserLogo}
                                alt="Clooser.nl"
                                width="2172"
                                height="724"
                                onLoad={(e) => {
                                 //console
                                }}
                                onError={(e) => {
                                    console.error("❌ LOGO IMAGE FAILED:", {
                                        src: e.target.src,
                                        error: e.target.error,
                                    });
                                }}
                            />
                        </a>

                        <section className="login-card" aria-labelledby="form-title">
                            <div className="card-heading">
                                <p className="eyebrow">CLOOSER</p>
                                <h1 id="form-title" tabIndex={-1}>Welkom terug</h1>
                                <p id="form-intro">Log in op uw Clooser-omgeving.</p>
                            </div>

                            <Formik
                                initialValues={{
                                    username: '',
                                    password: '',
                                    rememberToken: ''
                                }}
                                validationSchema={SignupSchema}
                                onSubmit={async (data) => {
                                    handleSubmit(data);
                                }}>
                                {props => (
                                    <Form noValidate>
                                        <div className="field">
                                            <label htmlFor="username">Gebruikersnaam</label>
                                            <input
                                                id="username"
                                                name="username"
                                                type="text"
                                                autoComplete="username"
                                                autoCapitalize="none"
                                                spellCheck="false"
                                                placeholder="Uw gebruikersnaam"
                                                aria-describedby="username-error"
                                                aria-invalid={!!(props.errors.username && props.touched.username)}
                                                onChange={props.handleChange}
                                                onBlur={props.handleBlur}
                                                value={props.values.username}
                                            />
                                            {props.errors.username && props.touched.username ? (
                                                <p className="field-error" id="username-error">{props.errors.username}</p>
                                            ) : null}
                                        </div>

                                        <div className="field">
                                            <div className="label-row">
                                                <label htmlFor="password">Wachtwoord</label>
                                            </div>
                                            <div className="password-input">
                                                <input
                                                    id="password"
                                                    name="password"
                                                    type={showPassword ? "text" : "password"}
                                                    autoComplete="current-password"
                                                    placeholder="Uw wachtwoord"
                                                    aria-describedby="password-error"
                                                    aria-invalid={!!(props.errors.password && props.touched.password)}
                                                    onChange={props.handleChange}
                                                    onBlur={props.handleBlur}
                                                    value={props.values.password}
                                                />
                                                <button
                                                    type="button"
                                                    className="eye-button"
                                                    aria-label={showPassword ? "Wachtwoord verbergen" : "Wachtwoord tonen"}
                                                    aria-pressed={showPassword}
                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                >
                                                    <svg className="eye-open" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" /><circle cx="12" cy="12" r="3" /></svg>
                                                    <svg className="eye-closed" viewBox="0 0 24 24" aria-hidden="true"><path d="m3 3 18 18M10.6 5.1A13 13 0 0 1 12 5c6.5 0 10 7 10 7a18 18 0 0 1-3 3.8M6.1 6.1A22 22 0 0 0 2 12s3.5 7 10 7a12 12 0 0 0 5.9-1.9M10 10a3 3 0 0 0 4 4" /></svg>
                                                </button>
                                            </div>
                                            {props.errors.password && props.touched.password ? (
                                                <p className="field-error" id="password-error">{props.errors.password}</p>
                                            ) : null}
                                        </div>

                                        <div className="recovery-row">
                                            <a className="text-button" id="forgot-password" href="#" onClick={handleForgotPassword}>
                                                Wachtwoord vergeten?
                                            </a>
                                        </div>

                                        <button className="primary-button" type="submit" disabled={isButtonDisabled}>
                                            <span>Inloggen</span>
                                            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m-6-6 6 6-6 6" /></svg>
                                        </button>

                                        {error ? (
                                            <div className="form-notice notice-error" role="status">
                                                {error}
                                            </div>
                                        ) : null}
                                    </Form>
                                )}
                            </Formik>

                            <div className="card-footers">
                                <span>Komt u er niet uit?</span>
                                <a href="https://www.clooser.nl/vervangers/contact/" target="_blank" rel="noopener noreferrer">
                                    Wij helpen u graag
                                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M7 7h10v10" /></svg>
                                </a>
                            </div>
                        </section>
                    </div>
                </main>

                {/* 2FA / QR enrollment modal — unchanged logic, kept as its own modal design */}
                <Modal isOpen={showQRModal} className={`modal-centered two-factor-authentication-modal ${recoveryCode ? "max-width" : ''}`}>
                    <ModalHeader className='modalHeader modal-header-color'>
                        2FA Inschakelen
                    </ModalHeader>
                    <ModalBody className='modalBody-centered'>
                        {recoveryCode && (
                            <>
                                <p className='pb-3 pt-3 head'>Dit zijn je herstelcodes</p>
                                <div className="row">
                                    {recoveryCode.map((code, index) => (
                                        <div key={index} className={`col-md-6 pb-3 ${index % 2 !== 0 ? "d-flex" : ""}`}>
                                            <p className={`text-monospace ${index % 2 !== 0 ? "margin-50" : ""}`}>{code}</p>
                                        </div>
                                    ))}
                                </div>
                                <p>De herstelcode is een belangrijk onderdeel binnen de tweefactorauthenticatie. Deze unieke codes worden eenmalig verstrekt tijdens inschakelen van 2FA. Een herstelcode kan worden gebruikt in het geval je geen toegang meer hebt tot de tweefactorauthenticatie-methode. Bewaar deze herstelcodes op een veilige plaats.</p>
                            </>)}
                        {recoveryCode && (
                            <ModalFooter className="d-flex justify-content-center">
                                <Button
                                    color="link"
                                    className="btn-color-style"
                                    onClick={toggleModal}
                                >

                                    doorgaan met inloggen
                                </Button>
                            </ModalFooter>
                        )}

                        {!recoveryCode && (
                            qrCodeSVG ? (
                                <div className="text-center mb-4" >
                                    <img
                                        src={qrCodeSVG}
                                        alt="QR Code"
                                    />
                                </div>
                            ) : (
                                qrError === '' ? <Loader className="mx-auto w-30 mb-4" type="ball-grid-pulse" /> :
                                    <div className="text-danger ps-3">{qrError}</div>
                            )
                        )}

                        {!recoveryCode && qrError === '' && (
                            <Formik
                                initialValues={{
                                    verification_code: '',
                                }}
                                validationSchema={validationSchema}
                                onSubmit={(values, { setFieldError }) =>
                                    enableTwoFactorAuthentication(values, setFieldError)
                                }
                            >
                                {({ setFieldValue, handleSubmit, values, handleBlur, errors, touched }) => (
                                    <Form onSubmit={handleSubmit}>
                                        <FormGroup className='input'>
                                            <Label for="2fa-code">
                                                Twee-Factor (2FA) code
                                            </Label>
                                            <Input
                                                onChange={(e) => setFieldValue('verification_code', e.target.value)}
                                                id="2fa-code"
                                                name="2fa-code"
                                                type="text"
                                                value={values.verification_code}
                                                onBlur={handleBlur}
                                            />
                                            {touched.verification_code && errors.verification_code && (
                                                <div className="invalid-feedback d-block">{errors.verification_code}</div>
                                            )}

                                        </FormGroup>

                                        <ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4 mt-4">

                                            <div className="text-center">
                                                <div>

                                                    {data?.enabled === 0 && (
                                                        <>
                                                            {!emailSent && (
                                                                <p style={{ color: "#4291CF", textAlign: "center", marginBottom: "15px" }}>
                                                                    <a
                                                                        href="#"
                                                                        className="text-decoration-underline ms-1"
                                                                        style={{ color: "#4291CF" }}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleLink(setFieldValue);;
                                                                        }}
                                                                    >
                                                                        Ontvang uw verificatiecode per mail
                                                                    </a>
                                                                </p>
                                                            )}

                                                            {emailSent && timer > 0 && (
                                                                <p style={{ color: "#39A825", textAlign: "center", marginBottom: "15px" }}>
                                                                    2fa e-mail verzonden. Opnieuw verzenden  {formatTime(timer)}
                                                                </p>
                                                            )}
                                                        </>
                                                    )}
                                                </div>

                                                <div>

                                                    <Button type='submit' color="link" className={"btn-color-style"} disabled={ButtonDisabled}>
                                                        Toepassen
                                                    </Button>
                                                </div>
                                            </div>

                                        </ModalFooter>
                                    </Form>
                                )}
                            </Formik>
                        )
                        }

                        {
                            (recoveryCode || qrError !== '') && <ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4 mt-2">
                                {qrError !== '' && <Button color="link" className={"btn-color-style"} onClick={generateQR}>
                                    Opnieuw Proberen
                                </Button>}
                            </ModalFooter>
                        }

                    </ModalBody>
                </Modal>
                {showOTPModal && (
                    <TwoFAModal
                        showOTPModal={showOTPModal}
                        setShow2FAModal={setShowOTPModal}
                        setShowQRModal={setShowQRModal}
                        handleOTPSubmit={handleOTPSubmit}
                        otp={otp}
                        setOtp={setOtp}
                        fetchProfileData={data}
                        error={error}
                        setError={setError}
                        generateQR={generateQR}
                        setVerifyType={setVerifyType}
                        setVerifyEnable={setVerifyEnable}
                        skipAutoEmailFlow={verifyType === 'auth'}


                    />
                )}
            </div>
        </Fragment>
    )
}

export default LoginBoxed;
